import Rellax from 'rellax/rellax.js';
import { breakpoints } from '../components/breakpoints';

export default function galleryStyleOverlay() {
  $(
    '.wp-block-gallery.is-style-overlay, .wp-block-gallery.is-style-overlay-reverse'
  ).each(function () {
    // Parallax effect on desktop only
    if (
      $(window).width() >= breakpoints.xl &&
      !Modernizr.touchevents &&
      Modernizr.pointerevents
    ) {
      const gallery = $(this).get(0);
      const item = $(this).find('.blocks-gallery-item:last-child').get(0);
      const parallax = new Rellax(item, {
        speed: -0.75,
        center: true,
      });
    }
  });
}
